/**
 * Vertical parallax for IF Image Banner — scroll-linked translateY on background images.
 * Matches typical hero/slider behavior: transform updates continuously while scrolling
 * (e.g. translateY(-59.8962px) based on section position in the viewport).
 */
(function () {
  if (typeof window === 'undefined') return;

  /* Modern browsers: CSS view-timeline parallax (see if_image_banner.liquid @supports) */
  function cssScrollParallaxSupported() {
    if (!window.CSS || !window.CSS.supports) return false;
    return (
      window.CSS.supports('animation-timeline: view()') ||
      window.CSS.supports('animation-timeline', 'view()')
    );
  }
  if (cssScrollParallaxSupported()) return;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Classic viewport parallax: image shifts opposite to scroll direction.
   * translateY = sectionRect.top * speed → negative values as the section moves up past the viewport.
   */
  function applyParallax(sectionRoot, img) {
    if (!sectionRoot || !img) return;

    var speedAttr = sectionRoot.getAttribute('data-parallax-speed');
    var speed =
      speedAttr !== null && speedAttr !== '' ? parseFloat(speedAttr) : 0.18;
    if (!Number.isFinite(speed) || speed <= 0) speed = 0.18;

    var rect = sectionRoot.getBoundingClientRect();
    var translateY = rect.top * speed;

    img.style.transform = 'translate3d(0, ' + translateY.toFixed(4) + 'px, 0)';
  }

  function updateAll() {
    var reduce = prefersReducedMotion();

    document.querySelectorAll('.if-image-banner[data-parallax-y="true"]').forEach(function (root) {
      root.querySelectorAll('.banner__media--parallax-y').forEach(function (media) {
        var img = media.querySelector('img');
        if (!img) return;

        if (reduce) {
          img.style.transform = '';
          return;
        }

        applyParallax(root, img);
      });
    });
  }

  var ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updateAll();
    });
  }

  if (!window.__ifImageBannerParallaxListeners) {
    window.__ifImageBannerParallaxListeners = true;
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    document.addEventListener('shopify:section:load', function () {
      requestAnimationFrame(updateAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        requestAnimationFrame(updateAll);
      },
      { once: true }
    );
  }
  requestAnimationFrame(updateAll);
})();
